import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';

import commonEn from './locales/en/common.json';
import commonRo from './locales/ro/common.json';

// The `common` namespace is loaded eagerly because it is used on every page.
// All other namespaces are lazy-loaded on demand via dynamic imports.
i18n
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      if (namespace === 'common') {
        // Return the already-imported bundle so it is available instantly
        const bundle = language === 'en' ? commonEn : commonRo;
        return Promise.resolve(bundle);
      }
      // Dynamic import — bundler splits every locale file into its own chunk
      return import(`./locales/${language}/${namespace}.json`);
    })
  )
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('language') || 'ro',
    fallbackLng: 'ro',
    defaultNS: 'common',
    ns: ['common'],
    // Pre-load the common namespace for both languages so the app
    // never shows untranslated keys on first render.
    preload: ['en', 'ro'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
